import React, { useCallback } from 'react'
import { TextField } from '@mui/material'
import { grayText2 } from '@/constant'
import { isEmpty } from '@/utils'
import { ImageIcon } from '@/icon'
import search_icon from '@/asset/img/search_icon.webp'
import ClearIcon from '@mui/icons-material/Clear'
import { KeywordSearchProps } from './KeywordSearch'

export const KeywordSearchOutlined: React.FC<KeywordSearchProps> = (props) => {
  const { value, onChange, onSearch, clear, onClear, placeholder, sx } = props

  const handleInputChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const input = event?.target?.value ?? ''
      if (!isEmpty(input)) {
        onChange(input?.trim())
      } else {
        onChange('')
      }
    },
    [onChange]
  )

  const onKeyUp = useCallback(
    (event: React.KeyboardEvent) => {
      const key = event?.code
      if (key === 'Enter') {
        event.preventDefault()
        onSearch && onSearch()
      }
    },
    [onSearch]
  )

  const handleClear = useCallback(() => {
    onChange('')
    onClear && onClear()
  }, [onChange, onClear])

  return (
    <TextField
      sx={{ borderRadius: '4px', width: '252px', ...sx }}
      placeholder={placeholder ?? '搜索'}
      size='small'
      variant='outlined'
      InputProps={{
        startAdornment: <ImageIcon src={search_icon} sx={{ width: '14px' }} />,
        endAdornment: clear && !isEmpty(value) && (
          <ClearIcon
            sx={{ cursor: 'pointer' }}
            fill={grayText2}
            onClick={handleClear}
          />
        ),
        style: {
          fontSize: '14px',
        },
      }}
      inputProps={{ style: { padding: '6px 14px' } }}
      value={value}
      onChange={handleInputChange}
      onKeyUp={onKeyUp}
    />
  )
}
